import { useRef } from 'react'
import { Modal } from 'react-daisyui'
import { Button } from '@/components/Button.tsx'
import { IconTrash } from '@tabler/icons-react'

interface DeleteConfirmModalProps {
  modalRef: React.RefObject<HTMLDialogElement>
  onConfirm: () => void
  isLoading?: boolean
  title?: string
  message?: string
}

export function useDeleteConfirmModal() {
  const modalRef = useRef<HTMLDialogElement>(null)
  const show = () => modalRef.current?.showModal()
  const close = () => modalRef.current?.close()
  return { modalRef, show, close }
}

export function DeleteConfirmModal({
  modalRef,
  onConfirm,
  isLoading,
  title = 'Löschen bestätigen',
  message = 'Möchtest du diesen Eintrag wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
}: DeleteConfirmModalProps) {
  return (
    <Modal ref={modalRef} className="bg-neutral">
      <Modal.Header>
        <div className="flex flex-col items-center gap-3 pt-2">
          <div className="bg-error bg-opacity-20 text-error rounded-full p-4">
            <IconTrash size={36} />
          </div>
          <span className="text-xl font-bold text-center">{title}</span>
        </div>
        <form method="dialog">
          <button className="btn btn-sm btn-circle btn-ghost absolute right-5 top-5">✕</button>
        </form>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col gap-4 items-center">
          <p className="text-center text-base-content opacity-80">{message}</p>
          <div className="flex flex-row gap-3 justify-center">
            <form method="dialog">
              <Button color="ghost" disabled={isLoading}>Abbrechen</Button>
            </form>
            <Button color="error" onClick={onConfirm} loading={isLoading} disabled={isLoading}>
              Löschen
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}
